import * as React from "react";
import { hot } from "react-hot-loader";
import DataProviderSharePoint from '../../../dataproviders/DataProvidersSharePoint';
import { IInputFormSharePoint } from '../../../interfaces/IInputFormSharePoint';
import CustomInput from '../../CustomInput/CustomInput';
import { CustomInputService } from '../../CustomInput/CustomInputService';
import { IFormulaireFileInputProps } from './IFormulaireFileInputProps';
import { IFormulaireFileInputState } from './IFormulaireFileInputState';
declare var libelle: any;
declare var configcustoms: any;

class FormulaireFileInput extends React.Component<IFormulaireFileInputProps, IFormulaireFileInputState> {

    private _dataProvider = new DataProviderSharePoint();

    constructor(props) {
        super(props);

        const fileExist = this.checkIfFileExist(this.props.InputFormSharePoint.InternalName);
        // Init du state
        this.state = {
            IsValidForm: false,
            IsFirstSubmit: true,
            IsReady: false,
            OnDownload: false,
            OnDelete: false,
            OnUpload: false,
            InputState: this.props.InputFormSharePoint,
            InputStateFile: {
                ...this.props.InputFormSharePointList[this.props.InputFormSharePoint.InternalName + "_file"],
                FileName: fileExist,
            },
            FileExist: fileExist,
        }

        this.handleChange = this.handleChange.bind(this);
        this.downloadPJ = this.downloadPJ.bind(this);
        this.deletePJ = this.deletePJ.bind(this);
    }

    public componentDidMount() {
        this.initFormInputSharePoint();
    }

    public render() {

        const disabledInputFile = this.state.OnDelete || this.state.OnDownload || this.state.OnUpload;
        return (
            this.state.IsReady &&
            <form className="pt-1 pb-4" noValidate={true}>
                <CustomInput HandleChange={this.handleChange} InputForm={this.state.InputStateFile}
                    IsFirstSubmit={this.state.IsFirstSubmit} FileExist={this.state.FileExist !== ''}
                    OnUpload={this.state.OnUpload} OnDelete={this.state.OnDelete} OnDownload={this.state.OnDownload} />
                <button type="button" className="btn btn-secondary mr-3 mb-1 mb-sm-0" onClick={this.downloadPJ} disabled={!this.state.FileExist || disabledInputFile}>
                    <div className="d-flex flex-row">
                        {this.state.OnDownload &&
                            <span className="spinner-border spinner-border-sm mr-1 align-self-center" role="status" aria-hidden="true" />
                        }
                        {libelle.formulaireFileInput.btnVisualiser}
                    </div>
                </button>
                <button type="button" className="btn btn-danger mb-1 mb-sm-0" onClick={this.deletePJ} disabled={!this.state.FileExist || this.state.InputState.IsReadOnly || disabledInputFile}>
                    <div className="d-flex flex-row">
                        {this.state.OnDelete &&
                            <span className="spinner-border spinner-border-sm mr-1 align-self-center" role="status" aria-hidden="true" />
                        }
                        {libelle.formulaireFileInput.btnSupprimer}
                    </div>
                </button>
            </form>
        );
    }

    private handleChange(event): void {

        if (this.state.InputState.IsReadOnly) {
            return;
        }

        const file = event.target.files[0];

        if (!this.formValidation(true, "" + file.size, file.name, file)) {
            return;
        }

        this.setState({ OnUpload: true });
        // Check si il exist déjà, si oui, on le supprime
        if (this.state.FileExist !== '') {
            // DELETE File on serv
            this._dataProvider.deletePJ(this.props.loginName, this.props.candidatureId, this.state.FileExist).then(deletePJ => {
                if (!deletePJ.OK) {
                    this.resultDeleteNotOk(this.state.InputStateFile, libelle.formulaireFileInput.errorDeletePJSharePoint);
                    return;
                }

                this.uploadPJ(file);
            });
        } else {
            // Sinon ou l'ajoute direct
            this.uploadPJ(file);
        }

        // Tricks pour tomber dans le handle change 
        // même si on remet le même fichier dans l'input file
        event.target.value = "";
    }

    private uploadPJ(file: any) {

        if (this.state.InputState.IsReadOnly) {
            return;
        }

        // Mettre a jour le file > InputStateFile
        const extension = file.name.split('').reverse().join('').split(/\.(.+)/)[0];
        const fileName = this.state.InputState.InternalName + "." + extension.split('').reverse().join('');

        this._dataProvider.uploadPJ(this.props.loginName, this.props.candidatureId, fileName, file).then(fileUploaded => {

            if (!fileUploaded.OK) {
                this.resultUploadNotOk(this.state.InputStateFile, libelle.formulaireFileInput.errorSavePJSharePoint);
                return;
            }

            // Mettre a jour le champ share point to true > InputState
            this.state.InputState.Value = this.state.InputState.Choices != null ? this.state.InputState.Choices.split(";")[0] : "Oui";
            this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, this.state.InputState.InternalName, this.state.InputState.Value, "Choice").then(result => {
                if (!result.OK) {
                    // Retry
                    (async () => {
                        // Do something before delay
                        await this.delay(1000);

                        // Do something after
                        this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, this.state.InputState.InternalName, this.state.InputState.Value, "Choice").then(resultTwo => {

                            // If failed
                            if (!resultTwo.OK) {
                                this.resultUploadNotOk(this.state.InputStateFile, libelle.formulaireFileInput.errorSavePJSharePoint);
                            }
                        });
                    })();
                }
            });

            // Send OnInputChange
            this.state.InputStateFile.FileName = fileName;
            this.props.OnInputChange(this.state.InputState);
            this.setState({ FileExist: fileName, OnUpload: false, InputStateFile: this.state.InputStateFile });
        });
    }

    private async delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private resultUploadNotOk(inputNotOk: IInputFormSharePoint, errorMessage: string) {
        inputNotOk.Value = "";
        inputNotOk.IsValid = false;
        inputNotOk.Message = errorMessage;

        this.props.OnInputIsValid(this.state.InputState.InternalName, inputNotOk.IsValid);
        this.setState({ IsValidForm: false, IsFirstSubmit: false, FileExist: '', OnDelete: false, OnDownload: false, OnUpload: false });
        this.props.OnInputChange(inputNotOk);
    }

    private checkIfFileExist(fileName: string): string {
        let fileExist = '';

        this.props.PJSharePointList.map(pj => {
            const tmpPjNameOnServ = pj.Name.split('').reverse().join('').split(/\.(.+)/)[1];
            const tmpPjNameLocal = fileName.split('').reverse().join('').split(/\.(.+)/)[1] != null ? fileName.split('').reverse().join('').split(/\.(.+)/)[1] : fileName.split('').reverse().join('');
            if (tmpPjNameOnServ === tmpPjNameLocal) {
                fileExist = pj.Name;
            }
        });

        return fileExist;
    }

    private downloadPJ(): void {

        // Download le file > InputState
        this.setState({ OnDownload: true });
        this._dataProvider.downloadPJ(this.props.loginName, this.props.candidatureId, this.state.FileExist).then(resp => {
            this.setState({ OnDownload: false });
        });
    }

    private deletePJ(): void {

        if (this.state.InputState.IsReadOnly) {
            return;
        }

        // Delete le file > InputStateFile
        this.setState({ OnDelete: true });
        this._dataProvider.deletePJ(this.props.loginName, this.props.candidatureId, this.state.FileExist).then(deletePJ => {

            if (!deletePJ.OK) {
                this.resultDeleteNotOk(this.state.InputStateFile, libelle.formulaireFileInput.errorDeletePJSharePoint);
                return;
            }

            const inputFileDom = document.getElementById(this.state.InputStateFile.Name);
            if (inputFileDom != null) {
                inputFileDom['value'] = "";
            }

            // Mettre a jour le champ share point to false > InputState
            this.state.InputState.Value = this.state.InputState.Choices != null ? this.state.InputState.Choices.split(";")[1] : "Non";
            this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, this.state.InputState.InternalName, this.state.InputState.Value, "Choice");

            // Send OnInputChange
            this.state.InputStateFile.FileName = "";
            this.props.OnInputChange(this.state.InputState);
            this.setState({ FileExist: '', OnDelete: false, InputStateFile: this.state.InputStateFile }, () => {
                // Re-Validation du form
                this.formValidation(true, "", "", null);
            });
        });
    }

    private resultDeleteNotOk(inputNotOk: IInputFormSharePoint, errorMessage: string) {
        inputNotOk.IsValid = false;
        inputNotOk.Message = errorMessage;

        this.props.OnInputIsValid(this.state.InputState.InternalName, inputNotOk.IsValid);
        this.setState({ IsValidForm: false, IsFirstSubmit: false, OnDelete: false, OnDownload: false, OnUpload: false });
        this.props.OnInputChange(inputNotOk);
    }

    private initFormInputSharePoint(): void {

        this.setState({ IsReady: true }, () => {
            this.formValidation(false, "", "", null);
        });

        this.props.OnInputIsReady(this.state.InputState.InternalName);
    }

    private formValidation(changeFirstSubmit: boolean, fileSize: string, fileName: string, fileContent: any): boolean {
        let isValidForm = true;
        let isFirstSubmit = this.state.IsFirstSubmit;

        if (isFirstSubmit && changeFirstSubmit) {
            isFirstSubmit = false;
        }

        const inputCheck = CustomInputService.validInput(this.state.InputStateFile, fileSize, this.props.InputFormSharePointList, this.state.FileExist !== '', fileName, fileContent);
        if (!inputCheck.IsValid) {
            isValidForm = false;
        }
        this.props.OnInputIsValid(this.state.InputState.InternalName, inputCheck.IsValid);

        this.setState({ IsValidForm: isValidForm, IsFirstSubmit: isFirstSubmit });

        return isValidForm;
    }

}

export default hot(module)(FormulaireFileInput);
